export default __webpack_public_path__ + "c9be7c15322fe9013b249431815e6650.svg";